(function () {
  var bar = document.querySelector('.js-spend-save-bar');
  if (!bar) return;

  var tiers = JSON.parse(bar.dataset.tiers)
    .filter(function (t) { return t.t > 0; })
    .sort(function (a, b) { return a.t - b.t; });
  if (!tiers.length) return;

  var msgEl = bar.querySelector('.spend-save-bar__msg');
  var trackEl = bar.querySelector('.spend-save-bar__track');
  var fillEl = bar.querySelector('.spend-save-bar__fill');
  var maxT = tiers[tiers.length - 1].t;

  function formatMoney(cents) {
    var dollars = Math.ceil(cents / 100);
    return '$' + dollars.toLocaleString('en-US');
  }

  function buildCheckpoints() {
    tiers.forEach(function (tier) {
      var cp = document.createElement('div');
      cp.className = 'spend-save-bar__checkpoint';
      cp.style.left = (tier.t / maxT * 100) + '%';
      cp.dataset.threshold = tier.t;

      var pctLabel = document.createElement('span');
      pctLabel.className = 'spend-save-bar__checkpoint-pct';
      pctLabel.textContent = tier.p + '%';

      var amtLabel = document.createElement('span');
      amtLabel.className = 'spend-save-bar__checkpoint-amt';
      amtLabel.textContent = formatMoney(tier.t);

      cp.appendChild(pctLabel);
      cp.appendChild(amtLabel);
      trackEl.appendChild(cp);
    });
  }

  function updateCheckpoints(subtotalCents) {
    var checkpoints = trackEl.querySelectorAll('.spend-save-bar__checkpoint');
    checkpoints.forEach(function (cp) {
      var threshold = parseInt(cp.dataset.threshold, 10);
      cp.classList.toggle('is-active', subtotalCents >= threshold);
    });
  }

  function updateBar(subtotalCents, itemCount) {
    bar.style.display = '';

    fillEl.style.width = Math.min(100, Math.max(0, subtotalCents / maxT * 100)) + '%';
    updateCheckpoints(subtotalCents);

    var currentTier = null;
    var nextTier = null;
    for (var i = 0; i < tiers.length; i++) {
      if (subtotalCents >= tiers[i].t) {
        currentTier = tiers[i];
      } else {
        nextTier = tiers[i];
        break;
      }
    }

    if (nextTier === null) {
      msgEl.textContent = 'You unlocked ' + currentTier.p + '% off.';
    } else if (currentTier === null) {
      msgEl.textContent = 'Spend ' + formatMoney(tiers[0].t - subtotalCents) + ' more to unlock ' + tiers[0].p + '% off.';
    } else {
      msgEl.textContent = 'You unlocked ' + currentTier.p + '% off. Spend ' + formatMoney(nextTier.t - subtotalCents) + ' more to unlock ' + nextTier.p + '% off.';
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBar(cart.original_total_price, cart.item_count);
      })
      .catch(function () {});
  }

  var debounceTimer;
  function debouncedFetch(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndUpdate, delay || 300);
  }

  buildCheckpoints();
  fetchAndUpdate();

  var itemsEl = document.querySelector('.js-ajax-cart-items');
  if (itemsEl) {
    new MutationObserver(function () { debouncedFetch(300); }).observe(itemsEl, { childList: true, subtree: true });
  }

  var subtotalEl = document.querySelector('.js-ajax-cart-subtotal');
  if (subtotalEl) {
    new MutationObserver(function () { debouncedFetch(300); }).observe(subtotalEl, { childList: true, subtree: true });
  }

  var cartContainer = document.querySelector('#AjaxCartContainer');
  if (cartContainer) {
    cartContainer.addEventListener('click', function (e) {
      if (
        e.target.closest('[data-behavior="increment"]') ||
        e.target.closest('[data-behavior="decrement"]') ||
        e.target.closest('[data-behavior="remove-line"]')
      ) {
        debouncedFetch(800);
      }
    });
  }
})();
